// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import AdultOnlyLogoUrl from '../../assets/img/mobile/jugadores-juego-responsable.png';
import { ReactComponent as ThumbIcon } from '../../assets/svg/thumb.svg';
import config from '../../config/app.config';
import { __, getLang } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import LongPressButton from '../LongPressButton';

const Wrapper = styled.div`
  font-size: 0.65em;
  padding: 1em;
  line-height: normal;
  color: ${theme.Legal.color};
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

const AdultOnlyLogo = styled.div`
  background-image: url(${AdultOnlyLogoUrl});
  background-size: 100%;
  background-repeat: no-repeat;
  margin: 0.3em 1em 0.3em 0em;
  width: 2em;
  height: 2em;
  max-width: 25px;
  max-height: 25px;
`;

const SvgWrapper = styled.div`
  position: relative;
  width: 2.2em;
  height: 2.2em;
  margin: 0.3em 1em 0.3em 0em;
  border-radius: 50%;
  background: ${theme.Legal.DE.svgBackground};
`;

const SvgThumb = styled(ThumbIcon)`
  fill: ${theme.Legal.color};
  &&&& {
    width: 60%;
    height: 60%;
    transform: translate(35%, 35%);
  }
`;

const StyledLink = styled.a`
  && {
    color: ${theme.Legal.color};
    text-decoration: underline;
  }
`;

const Top = styled.div`
  margin-bottom: 1em;
`;

const Bottom = styled.div`
  margin-top: 2em;
`;

const BZGAParagraph = styled.p`
  white-space: pre-wrap;
`;

const PanicPanel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: justify;
  margin-bottom: 1.5em;
`;

const PanicDescription = styled.div`
  margin-right: 2em;
`;

const StyledPanicButton = styled(LongPressButton)`
  font-size: 1.6em;
  width: 9em;
`;

type LegalDeProps = {
  connected: boolean;
  realMoney: boolean;
  handlePanicButtonPress?: () => void;
};

const LegalDe = ({ connected, realMoney, handlePanicButtonPress }: LegalDeProps) => {
  const panicButton = useMemo(() => {
    if (connected && realMoney) {
      return (
        <PanicPanel>
          <PanicDescription>{__('For a 24h break hold the button pressed for 3 seconds.')}</PanicDescription>
          <StyledPanicButton threshold={3000} onPress={handlePanicButtonPress}>
            {__('24-hour break')}
          </StyledPanicButton>
        </PanicPanel>
      );
    }
    return null;
  }, [connected, realMoney, handlePanicButtonPress]);
  return (
    <Wrapper>
      <Top>
        {panicButton}
        <LogoWrapper>
          <SvgWrapper>
            <SvgThumb />
          </SvgWrapper>
          <StyledLink
            target="_blank"
            rel="noopener noreferrer"
            href={`${config.webHost[getLang()]}/verantwortliches-spiel?external=1`}
          >
            {__('!desc:DVTMLink')}
          </StyledLink>
        </LogoWrapper>
        <LogoWrapper>
          <AdultOnlyLogo />
          {__('!desc:Minus18DE')}
        </LogoWrapper>
      </Top>
      <Bottom>
        <BZGAParagraph>
          {__('!desc:BzgaLegals')}{' '}
          <StyledLink target="_blank" rel="noopener noreferrer" href="https://www.bzga.de/?external=1">
            bzga.de
          </StyledLink>
        </BZGAParagraph>
      </Bottom>
    </Wrapper>
  );
};

export default React.memo<unknown>(LegalDe);
